import { DialogContent } from '@mui/material';

/**
 * SafeDialogContent - A wrapper around Material-UI DialogContent with Safari-friendly scrolling
 * 
 * Safari has issues with scrollbar styling and scrolling in dialogs. This component
 * applies fixes for smooth scrolling and proper scrollbar display across browsers.
 * 
 * Usage: Wrap dialog content with this component instead of DialogContent
 */
const SafeDialogContent = ({ children, sx = {}, ...props }) => {
    const safeSx = {
        // Critical: Explicitly enable vertical scrolling to fix Safari scroll issues
        // Safari sometimes fails to recalculate scroll dimensions when async content loads
        overflowY: 'auto',
        
        // Enable momentum/smooth scrolling on iOS and Safari
        WebkitOverflowScrolling: 'touch',
        
        // Establish positioning context for the scroll container
        position: 'relative',
        
        // Custom scrollbar styling for better visibility
        '&::-webkit-scrollbar': {
            width: 8,
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.3)',
            borderRadius: 4,
        },
        
        // Merge any custom sx props provided
        ...sx,
    };

    return (
        <DialogContent sx={safeSx} {...props}>
            {children}
        </DialogContent>
    );
};

export default SafeDialogContent;
